"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialConditionType = void 0;
var SpecialConditionType;
(function (SpecialConditionType) {
    SpecialConditionType[SpecialConditionType["BLOCKED"] = 1] = "BLOCKED";
    SpecialConditionType[SpecialConditionType["UNBILLABLE"] = 2] = "UNBILLABLE";
    SpecialConditionType[SpecialConditionType["FREE"] = 3] = "FREE";
    SpecialConditionType[SpecialConditionType["OVERRIDE_ON_NET"] = 4] = "OVERRIDE_ON_NET";
    SpecialConditionType[SpecialConditionType["DONT_VALIDATE"] = 5] = "DONT_VALIDATE";
    SpecialConditionType[SpecialConditionType["OVERRIDE_QUIET_DETECT"] = 6] = "OVERRIDE_QUIET_DETECT";
    SpecialConditionType[SpecialConditionType["PASSIVE_ACCEPT"] = 7] = "PASSIVE_ACCEPT";
    SpecialConditionType[SpecialConditionType["TIME_DURATION_EXCEPTION"] = 8] = "TIME_DURATION_EXCEPTION";
    SpecialConditionType[SpecialConditionType["EXCLUDED"] = 9] = "EXCLUDED";
    SpecialConditionType[SpecialConditionType["ALLOW_DTMF"] = 10] = "ALLOW_DTMF";
    SpecialConditionType[SpecialConditionType["ANNOUNCEMENT_SKIP"] = 11] = "ANNOUNCEMENT_SKIP";
    SpecialConditionType[SpecialConditionType["ANNOUNCEMENT_DELAY_10"] = 12] = "ANNOUNCEMENT_DELAY_10";
    SpecialConditionType[SpecialConditionType["ALLOW_MULTIPLE_CALLS"] = 13] = "ALLOW_MULTIPLE_CALLS";
})(SpecialConditionType = exports.SpecialConditionType || (exports.SpecialConditionType = {}));
